"use client";

import { useLocale, useTranslations } from "next-intl";
import { useRouter, usePathname } from "@/i18n/navigation";
import {
  Button,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from "@nextui-org/react";
import { Icon } from "@iconify/react";

const languages = [
  { code: "fr", name: "Français", flag: "fr" },
  { code: "en", name: "English", flag: "gb" },
  { code: "pt", name: "Português", flag: "pt" },
];

export function LanguageSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations("language");

  const handleLanguageChange = (newLocale: string) => {
    router.replace(pathname, { locale: newLocale });
  };

  const currentLanguage = languages.find((lang) => lang.code === locale);

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          variant="light"
          startContent={
            <Icon
              icon={`flag:${currentLanguage?.flag}-4x3`}
              className="h-4 w-4"
            />
          }
          className="text-sm font-medium"
        >
          {currentLanguage?.name}
        </Button>
      </DropdownTrigger>
      <DropdownMenu aria-label="Sélection de la langue">
        {languages.map((language) => (
          <DropdownItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className={locale === language.code ? "bg-primary/10" : ""}
            startContent={
              <Icon icon={`flag:${language.flag}-4x3`} className="h-4 w-4" />
            }
          >
            {language.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
